module.exports = __webpack_public_path__ + "img/criers-war.afb00aa2.png";